import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

import { resetDirtyFormQuestionnaire } from 'actions/questionnaires';

export const VALIDATE_FORM_REQUEST = 'VALIDATE_FORM_REQUEST';
export const VALIDATE_FORM_SUCCESS = 'VALIDATE_FORM_SUCCESS';
export const VALIDATE_FORM_FAILURE = 'VALIDATE_FORM_FAILURE';

function request() {
  return {
    type: VALIDATE_FORM_REQUEST
  };
}

function receive(validationResponse) {
  return {
    type: VALIDATE_FORM_SUCCESS,
    validationResponse
  };
}

function reject() {
  return {
    type: VALIDATE_FORM_FAILURE
  };
}

export function validate(formType, formId, formData) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .validateForm(formType, formId, formData)
      .then((response) => {
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}

export function validateQuestionnaire(formType, formId, formData) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .validateQuestionnaireForm(formType, formId, JSON.stringify(formData))
      .then((response) => {
        dispatch(resetDirtyFormQuestionnaire());
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}

export function validateFormGroupQuestionnaire(formGroupType, formGroupId, formData) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .validateFormGroupQuestionnaire(formGroupType, formGroupId, JSON.stringify(formData))
      .then((response) => {
        dispatch(resetDirtyFormQuestionnaire());
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}
